function videoView(id,props) {
	this.l = {
		"close": "Zamknij film"
	};


	this.ident = id;
	this.properties = props;
	this.photoLoaded = false;

	this.style = {'opacity': 0};
	this.state = 'transin';

	swipe = new swiper();	
}

videoView.prototype = {

	load: function() {
		AppEvent.trigger(player, "PLACE.LOADED", player.currentView);

		pd = $("<div class='videoView'></div>");
		this.node = pd;
		if (this.properties.bg != undefined && this.properties.bg != "") this.node.css("background-image","url(" + this.properties.bg + ")");

		//console.log(this.properties);

		pd.append($("<div class='vplayer'></div>"));
		this.playernode = pd.find(".vplayer");

		$("#ui").append(pd);

		this.media = new vplayer();		
		this.media.fitScreen(200, 150);

		this.playernode.append(this.media.embed());

		if (player.offline) {
			this.properties.video = this.properties.video.replace("/data", "data");
		}

		this.media.load(this.properties.video);

		this.media.setTitle(this.properties.place_name);

		this.close = $("<img src='assets/menu_close.png?123' alt='" + this.l['close'] + "' title='" + this.l['close'] + "' width='50' height='50' style='z-index:99999;position:absolute;right:10px;top:70px;cursor:pointer;pointer-events:all;'>");
		this.node.append(this.close);

		this.close.on(Events.pointer.up, function() {
			if ((player.lastIdent == undefined || player.lastIdent == null || player.lastIdent == player.ident) && player.current.properties.exit != undefined && player.current.properties.exit != "0") {
				player.addTrack(player.current.properties.exit, player.current.properties.exit_angle);
				player.lastIdent = player.current.properties.exit;
				player.lastDir = player.current.properties.exit_angle;
			}

			player.back();
		});
	},

	reorient: function() {
	},
	
	process: function() {
		switch (this.state) {
			case "transin":
				this.style.opacity ++;
				this.node.css("opacity", (this.style.opacity * 0.01));
				if (this.style.opacity >= 100) {
					AppEvent.trigger(player, "PLACE.TRANSITIONED", this);
					this.state = 'running';
				}
			break;

			case "running":
			break;

			case "transout":
			break;
		}
	},	

	mouseDown: function(event) {
	},
	
	mouseUp: function(event) {
	},
	
	mouseMove: function(event) {
	},

	mouseWheel: function(dt) {
	},
	
	clear: function() {
	},

	leaving: function() {
		var self = this;

		AppEvent.one(player, "PLACE.TRANSITIONED", function() {
			self.node.remove();
		});
	},

	pause: function() {
	},

	resume: function() {
	},

	getRX: function() {
		return 0;
	},

	getRY: function() {
		return 0;
	},

	stopTurning: function() {

	}
}